import { ROLES } from 'globalconfig/constants/keys';
import { hasEnabledFeature, hasRestrictedRole, objectArrayFromMultipleFields } from 'globalutils/fmUtils';
import React, { lazy, useState } from 'react';
import { downloadTypes } from './config';
import ViewForm from './Form';
import { checkServiceProvider } from './serviceProviderConfig';

const layout = window?.$environment?.CURRENT_LAYOUT;
const Button = lazy(() => import(`globalcomponents/UI/Button/${layout}`));
const AdvancedDvir = lazy(() => import(`@/modules/AdvancedDvir`));
const CustomDvir = lazy(() => import(`@/modules/CustomDvir`));
const Breadcrumb = lazy(() => import(`globalcomponents/Breadcrumb`));
const FormStyle = require(`globalcomponents/UI/Form/${layout}/serverStyle`);
const DatePopup = lazy(() => import(`@/modules/DatePopup/${layout}`));

const TopActions = ({
  isCustomDviRequired,
  isAdvancedDviRequired,
  i18n,
  history,
  list,
  bulkDownloadReport,
  apiStatus,
  clearApiStatus,
  callback,
  Styled,
  changeRequest,
  hasApiStatus,
  filters,
  setPagination,
}) => {
  const [isExportClicked, setIsExportClicked] = useState(false);

  const userList = objectArrayFromMultipleFields(list?.drivers, 'id', ['firstName', 'lastName']);

  return (
    <Styled.Wrapper>
      {layout !== 'OldUi' && <Breadcrumb filters={filters} />}
      <div className="buttonWrapper">
        {!hasRestrictedRole([ROLES.DRIVER, ROLES.MECHANIC]) && (
          <>
            <FormStyle.default.ButtonsWrapper className="advancedDVIR">
              {isCustomDviRequired && (
                <CustomDvir className="buttonStyle" label={i18n.t('inspections.customDvir')} history={history} />
              )}
            </FormStyle.default.ButtonsWrapper>
            <FormStyle.default.ButtonsWrapper
              className={window.$environment.CURRENT_LAYOUT === 'SpireonNew' ? '' : 'advancedDVIR'}
            >
              {isAdvancedDviRequired && (
                <AdvancedDvir className="buttonStyle" label={i18n.t('inspections.advancedDvir')} history={history} />
              )}
            </FormStyle.default.ButtonsWrapper>

            <FormStyle.default.ButtonsWrapper className="bulkDownload">
              {hasEnabledFeature('bulkDownloadEnabled') && (
                <Button
                  type="submit"
                  className="buttonStyle"
                  label={i18n.t('inspections.bulkDownloadReport')}
                  onClick={() => {
                    if (checkServiceProvider('topAction_bulkDownloadReport', window.$environment.SERVICE_PROVIDER, false)) {
                      setIsExportClicked(!isExportClicked);
                    } else {
                      setIsExportClicked(true);
                    }
                  }}
                />
              )}
            </FormStyle.default.ButtonsWrapper>
          </>
        )}
      </div>
      {!hasRestrictedRole([ROLES.DRIVER, ROLES.MECHANIC]) && (
        <DatePopup
          formId="bulkDownloadForm"
          isOpen={isExportClicked}
          setIsOpen={setIsExportClicked}
          submit={bulkDownloadReport}
          apiStatus={apiStatus}
          clearApiStatus={clearApiStatus}
          data={list?.list || []}
          callback={callback}
          drivers={userList}
          downloadTypes={downloadTypes}
          inspections
        />
      )}
      <ViewForm
        apiStatus={apiStatus}
        history={history}
        callback={callback}
        Styled={Styled}
        hasApiStatus={hasApiStatus}
        changeRequest={changeRequest}
        list={list}
        setPagination={setPagination}
      />
      <div className="breadcrumbClass">{layout === 'OldUi' && <Breadcrumb filters={filters} />}</div>
    </Styled.Wrapper>
  );
};
export default TopActions;
